import Circular from "./Circular";
import ButtonLoader from "./button-loader";

export default { ButtonLoader, Circular };
